import { CommonCompanyProfileWrite } from 'api/models/CommonCompanyProfileWrite';

export interface SaveConflict {
  conflict_field: string;
  conflict_profile: { id: number; name: string };
}

export interface ProfileFormState {
  name: string;
  cap_iq_id: string;
  sacra_domain: string;
  zanbato_id: string;
}

export interface CommonCompanyProfileFormProps {
  values: ProfileFormState;
  onChange: (values: ProfileFormState) => void;
  isLoading?: boolean;
  profileId?: number;
  onPendingEdgarAddsChange?: (ids: number[]) => void;
  onPendingEdgarRemovesChange?: (ids: number[]) => void;
  onHasConflicts?: (has: boolean) => void;
  saveConflicts?: SaveConflict[];
}

export const EMPTY_FORM_STATE: ProfileFormState = {
  name: '',
  cap_iq_id: '',
  sacra_domain: '',
  zanbato_id: '',
};

export const toWritePayload = (form: ProfileFormState): CommonCompanyProfileWrite => ({
  name: form.name,
  cap_iq_id: form.cap_iq_id || null,
  sacra_domain: form.sacra_domain || null,
  zanbato_id: form.zanbato_id || null,
});
